// Centralized React Query cache keys. One source of truth so invalidations
// don't drift. Pattern: [entity, uid, ...params].

export const qk = {
  appstate:  (uid: string) => ['appstate', uid] as const,
  projects:  (uid: string) => ['projects', uid] as const,
  project:   (uid: string, id: number) => ['projects', uid, id] as const,
  estimates: (uid: string) => ['estimates', uid] as const,
  estimate:  (uid: string, id: number) => ['estimates', uid, id] as const,
  expenses:  (uid: string) => ['expenses', uid] as const,
  payments:  (uid: string) => ['payments', uid] as const,
  schedules: (uid: string) => ['schedules', uid] as const,
  clients:   (uid: string) => ['clients', uid] as const,
  subs:      (uid: string) => ['subs', uid] as const,
  vendors:   (uid: string) => ['vendors', uid] as const,
  reminders: (uid: string) => ['reminders', uid] as const,
  changeOrders: (uid: string) => ['changeOrders', uid] as const,
  bids:      (uid: string) => ['bids', uid] as const,
  events:    (uid: string) => ['events', uid] as const,
  opts:      (uid: string) => ['opts', uid] as const,
  attachments: (uid: string) => ['attachments', uid] as const,

  assignments: (uid: string) => ['assignments', uid] as const,
  portalLinks: (uid: string) => ['portalLinks', uid] as const,
  team:        (code: string) => ['team', code] as const,
} as const
